import {
    NOT_AVAILABLE,
    formatMetric,
} from '~/containers/workflows/verify/segmetricsColumns';
import { ContourComparisonMetrics } from '~/domain/comparison/contourComparisonMetrics';

export interface ComparisonMetricRow {
    /** react-intl message id; the label carries the display unit. */
    labelId: string;
    /** Formatted value, or NOT_AVAILABLE when the metric is missing. */
    value: string;
}

/**
 * Maps client-computed comparison metrics to the three displayed rows.
 *
 * - DSC: unitless, 3 dp.
 * - HD95: mm, 1 dp (surface metric kept in mm per docs/ui_specs.md).
 * - MSD: mm, 2 dp — symmetric mean surface distance from `compareContours`.
 *   Now computed in-browser, so it is labelled "MSD" honestly rather than the
 *   former backend "Mean HD".
 *
 * Pure so the precision/unit mapping is unit-testable without a DOM.
 */
export function comparisonMetricRows(
    result: ContourComparisonMetrics
): ComparisonMetricRow[] {
    return [
        {
            labelId: 'compare.metric.dice',
            value: formatMetric(result.dice, 3) ?? NOT_AVAILABLE,
        },
        {
            labelId: 'compare.metric.hd95',
            value: formatMetric(result.hd95Mm, 1) ?? NOT_AVAILABLE,
        },
        {
            labelId: 'compare.metric.msd',
            value:
                formatMetric(result.meanSurfaceDistanceMm, 2) ?? NOT_AVAILABLE,
        },
    ];
}
